import Loader from './Loader.vue';
import useLoader from './useLoader';

export default Loader;

export {useLoader};
